import React from 'react';
import { keyframes } from '@emotion/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const spinCw = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const spinCcw = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(-360deg); }
`;

const glow = keyframes`
  0%, 100% { opacity: 0.5; transform: scale(0.88); }
  50%       { opacity: 1;   transform: scale(1.08); }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Ring = ({ size, border, color, duration, reverse, delay = 0 }) => (
  <Box
    sx={{
      position: 'absolute',
      width: size,
      height: size,
      borderRadius: '50%',
      border: `${border}px solid transparent`,
      borderTopColor: color,
      borderRightColor: `${color}55`,
      animation: `${reverse ? spinCcw : spinCw} ${duration}s linear ${delay}s infinite`,
    }}
  />
);

const CommonLoader = ({ fullScreen = false }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: fullScreen ? '100vh' : '180px',
      background: fullScreen
        ? 'linear-gradient(135deg, #0d1b2a 0%, #091420 100%)'
        : 'transparent',
      gap: 3,
    }}
  >
    {/* Spinner rings */}
    <Box sx={{ position: 'relative', width: 72, height: 72, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Ring size={72} border={3} color={DEFAULT_THEME_COLOR} duration={1.2} reverse={false} />
      <Ring size={52} border={2.5} color="#4facfe" duration={1.8} reverse={true} delay={0.1} />
      {/* Inner pulsing dot */}
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${DEFAULT_THEME_COLOR} 0%, #4facfe 100%)`,
          boxShadow: `0 0 12px ${DEFAULT_THEME_COLOR}88`,
          animation: `${glow} 1.4s ease-in-out infinite`,
        }}
      />
    </Box>

    {/* Brand label */}
    {fullScreen && (
      <Typography
        sx={{
          background: `linear-gradient(90deg, ${DEFAULT_THEME_COLOR}, #4facfe)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontWeight: 700,
          fontSize: '1rem',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          animation: `${fadeIn} 0.6s ease both`,
        }}
      >
        Freakland
      </Typography>
    )}
  </Box>
);

export default CommonLoader;
